import { STATE_META } from "@/lib/constants";

const TONES = {
  info: "bg-blue-50 text-blue-700 border-blue-200",
  muted: "bg-stone-100 text-stone-600 border-stone-200",
  brand: "bg-forest/10 text-forest border-forest/20",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  error: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ state }) {
  const meta = STATE_META[state] || { label: state, tone: "muted" };
  return (
    <span
      data-testid={`status-${state}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONES[meta.tone]}`}
    >
      {meta.label}
    </span>
  );
}
